import styled from 'styled-components';

type Props = {
  width?: string;
};

export const DangerButton = styled.button<Props>`
  opacity: 1;
  height: 48px;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: -0.25px;
  text-align: center;
  border-radius: 8px;
  width: 100%;
  :disabled {
    background: #666666;
    cursor: default;
    color: #ffffff;
    border: none;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.colors?.error.secondary.color};
  color: #ffffff;
  border: 1px solid #d8d8d8;
  width: ${props => (props.width ? props.width : 'auto')};
`;
